import { ApplyTypes, CustomerEligibility } from '../../gql/graphql';

export const isCurrentApplyTypeOTB = (currentApplyType?: ApplyTypes) => {
  return currentApplyType === ApplyTypes.LeaseOtb || currentApplyType === ApplyTypes.LoanOtb;
};

export const getCurrentApplyType = (eligibilityDetails?: CustomerEligibility): ApplyTypes | undefined => {
  return eligibilityDetails?.applyTypes?.[0];
};
